<div class="sk-cms-tab sk-cms-tab-pc pc-email" id="tab_{{id}}"
    {{if style.tabStyle.background.styleType == 'custom'}}
        {{if style.tabStyle.background.backgroundType == 'color'}}
            style="background-color:{{style.tabStyle.background.color}}"
        {{/if}}
        {{if style.tabStyle.background.backgroundType == 'img'}}
            style="background-image:url('{{style.tabStyle.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
    {{if style.tabStyle.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title}) %>
    {{/if}}

    {{if !content || !content.length}}
         <% include('../common/nodata.art') %>
    {{else}}

    <div class="tab-content-main">
        <div class="tab-main {{basic.style.type}} {{style.tabStyle.tabStyle}}"
            {{if style.tabStyle.defaultBack.styleType != 'default'}}
                {{if style.tabStyle.defaultBack.backgroundType == 'color'}}
                    style="background-color:{{style.tabStyle.defaultBack.color}}"
                {{/if}}
                {{if style.tabStyle.defaultBack.backgroundType == 'img'}}
                    style="background-image:url('{{style.tabStyle.defaultBack.imgUrl}}')"
                {{/if}}
            {{/if}}
        >
        {{each content}}
            {{if isDesign || isPreview}}
            <div class="tab"
                id="tab_{{id}}_{{$index}}"
                sk-event.click='changeTab({{$value}}, {{$index}}, {{id}}, {{style}})'
            >
                {{$value.title}}
            </div>
            {{else}}

            <div class="tab"
                id="tab_{{id}}_{{$index}}"
                sk-class="$data.activeIndex === {{$index}} ? ('{{style.tabStyle.selectedStyle.styleType}}' != 'default' ? '{{style.tabStyle.selectedStyle.fontSize}} activeTab' : 'activeTab') : ('{{style.tabStyle.unselectedStyle.styleType}}' != 'default' ? '{{style.tabStyle.unselectedStyle.fontSize}}' : '')"

                sk-style="{'background-color': ($data.activeIndex === {{$index}} && '{{style.tabStyle.selectedBack.styleType}}' != 'default' && '{{style.tabStyle.selectedBack.backgroundType}}' == 'color') ? '{{style.tabStyle.selectedBack.color}}' : '', 'background-image': ($data.activeIndex === {{$index}} && '{{style.tabStyle.selectedBack.styleType}}' != 'default' && '{{style.tabStyle.selectedBack.backgroundType}}' == 'img') ? url('{{style.tabStyle.selectedBack.imgUrl}}') : '', color: $data.activeIndex === {{$index}} && '{{style.tabStyle.selectedStyle.styleType}}' != 'default' ? '{{style.tabStyle.selectedStyle.color}}' : ($data.activeIndex !== {{$index}} && '{{style.tabStyle.unselectedStyle.styleType}}' != 'default' ?  '{{style.tabStyle.unselectedStyle.color}}' : '')}"

                sk-event.click='changeTab({{$value|json_encode|raw}}, {{$index}}, {{id}}, {{style|json_encode|raw}})'
            >
                {{$value.title}}
            </div>
            {{/if}}
        {{/each}}
        </div>
        {{each content tabContent}}
            <div class="tab-content" id="tabContent_{{id}}_{{$index}}"

            >
                <!-- 文件列表 -->
                {{if tabContent.contentType === 'FILE'}}
                <div>
                    <div class="sk-cms-file {{isPreview ? '': 'sk-component FILE'}}"
                        {{if style.file.background.styleType != 'default'}}
                            {{if style.file.background.backgroundType == 'color'}}
                                style="background-color:{{style.file.background.color}}"
                            {{/if}}
                            {{if style.file.background.backgroundType == 'img'}}
                                style="background-image:url('{{style.file.background.imgUrl}}')"
                            {{/if}}
                        {{/if}}
                    >
                        {{if !tabContent.items || !tabContent.items.length}}
                            <% include('../common/nodata.art') %>
                        {{else}}
                        <div class="file-main {{tabContent.contentLayout}} {{tabContent.styleLayout}}">
                        {{each tabContent.items}}
                        <div class="file-wrap" id="page_{{$index}}_items"
                            {{if $index == 0 }}
                                style="display: block"
                            {{/if}}
                        >
                            {{each $value}}
                            <div class="file-items {{style.file.lineStyle.model === 'custom' ? style.file.lineStyle.line : ''}} {{style.file.lineStyle.model === 'hide' ? 'hide': ''}}"
                                {{if style.file.lineStyle.model === 'custom'}}
                                style="border-color: {{style.file.lineStyle.color}}"
                                {{/if}}>
                                <div class="file-img"
                                    {{if isDesign && tabContent.styleLayout === 'column1'}}
                                    {{/if}}
                                >
                                    <img src="{{$value.imgUrl ? $value.imgUrl : '../../assets/images/img_default.jpg'}}" cms-smarket/>
                                </div>
                                <div class="file-con">
                                    {{if style.file.titleStyle.styleType !== 'hide'}}
                                    <div class="file-title {{ style.file.titleStyle.styleType === 'custom' ? style.file.titleStyle.fontSize : ''}}"
                                        style="{{style.file.titleStyle.styleType === 'custom' ? ('color:' + style.file.titleStyle.color) : ''}}">
                                        {{$value.title}}
                                    </div>
                                    {{/if}}
                                    <div class="file-bottom">
                                        {{if style.file.timeStyle.styleType !== 'hide'}}
                                        <div class="file-time {{ style.file.timeStyle.styleType === 'custom' ? style.file.timeStyle.fontSize : ''}}"
                                            style="{{style.file.timeStyle.styleType === 'custom' ? ('color:' + style.file.timeStyle.color) : ''}}">
                                            {{$value.pushTime}}
                                        </div>
                                        {{/if}}
                                        <div class="button-bar">
                                            {{if style.file.preButton.styleType !== 'hide'}}
                                            <div class="file-down preview {{style.file.preButton.fontSize}}"
                                                {{if style.file.preButton.styleType === 'custom'}}
                                                style="{{'color:' + style.file.preButton.color}}; background-color:{{style.file.preButton.backgroundColor}}; background-image: url('{{style.file.preButton.imgUrl}}')"
                                                {{/if}}
                                            >
                                                {{if !isDesign}}
                                                    {{if !isPreview}}
                                                    <a href="{{$value.link?$value.link:'javascript:void(0)'}}">预览</a>
                                                    {{else}}
                                                        {{if tabContent.addType == 1}}
                                                            <a href="{{$value.link?$value.link:'javascript:void(0)'}}">预览</a>
                                                        {{else}}
                                                           {{if $value.preview.type == 2}}
                                                             <a sk-prop.href="$data.fileDetail +  '&fid=' + {{$value.id}}">预览</a>
                                                             {{/if}}
                                                             {{if $value.preview.type == 3}}
                                                             <a href="{{$value.wapPreviewUrl.replace('filePreview','fileDetail')}}">预览</a>
                                                             {{/if}}
                                                             {{if $value.preview.type == 1}}
                                                             <a href="{{$value.wapPreviewUrl}}">预览</a>
                                                             {{/if}}
                                                        {{/if}}
                                                    {{/if}}
                                                {{else}}
                                                <span>预览</span>
                                                {{/if}}
                                            </div>
                                            {{/if}}

                                            {{if style.file.downloadButton.styleType !== 'hide'}}
                                                <div class="file-down {{style.file.downloadButton.fontSize}}"
                                                    {{if style.file.downloadButton.styleType === 'custom'}}
                                                    style="{{'color:' + style.file.downloadButton.color}}; background-color:{{style.file.downloadButton.backgroundColor}}; background-image: url('{{style.file.downloadButton.imgUrl}}')"
                                                    {{/if}}
                                                >
                                                    {{if !isDesign}}
                                                    <a cms-value-raw sk-event.click='downLoad({{tabContent.addType}}, {{$value}}, {{id}})'
                                                    href="javascript:void(0);">下载</a>
                                                    {{else}}
                                                    <span>下载</span>
                                                    {{/if}}
                                                </div>
                                            {{/if}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {{/each}}
                        </div>
                        {{/each}}
                        </div>
                        {{/if}}
                    </div>
                    {{if style.file.pagination.model !== 'hide'}}
                     {{if isDesign || isPreview}}
                        <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style="{{style.file.pagination}}">
                        </div>
                        {{else}}
                        <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style='{{style.file.pagination|json_encode|raw}}'>
                        </div>
                     {{/if}}
                    {{/if}}
                </div>
                {{/if}}
                <!-- 文章列表 -->
                {{if tabContent.contentType === 'MIMAGETEXT'}}
                <div>
                    <div class="sk-cms-mimage-text"
                        {{if style.article.background.styleType != 'default'}}
                            {{if style.article.background.backgroundType == 'color'}}
                                style="background-color:{{style.article.background.color}}"
                            {{/if}}
                            {{if style.article.background.backgroundType == 'img'}}
                                style="background-image:url('{{style.article.background.imgUrl}}')"
                            {{/if}}
                        {{/if}}
                    >
                        {{if !tabContent.items || !tabContent.items.length}}
                            <% include('../common/nodata.art') %>
                        {{else}}
                        {{each tabContent.items}}
                        <div class="file-wrap" id="page_{{$index}}_items"
                            {{if $index == 0 }}
                                style="display: block"
                            {{/if}}
                        >
                            <div class="sk-cms-image-text-list sk-cms-detail-dom {{tabContent.styleLayout}}"> <!--column2 column3 column4 一二三四列-->
                                {{each $value}}
                                 <div class="item {{style.article.lineStyle.model != 'hide' ? 'border-'+ style.article.lineStyle.line : ''}} {{tabContent.contentLayout}}" style="border-color: {{style.article.lineStyle.color}};"><!--layout-img-top上下类型  layout-img-left左右类型 layout-img-no无图类型-->
                                     {{if $value.linkType != 'none' && isPreview && !isDesign}}
                                          {{if tabContent.addType == 1}}
                                              <a class="goto-link" target="_blank" href="{{$value.link}}">
                                          {{else}}
                                              {{if $value.useLinkUrl == 1}}
                                                   <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                              {{else}}
                                                {{if $value.id}}
                                                   <a target="_blank" sk-prop.href="$data.articleDetail + '&aid=' + {{$value.id}}">
                                                {{else}}
                                                    <a target="_blank" sk-prop.href="$data.articleDetail">
                                                {{/if}}
                                              {{/if}}
                                          {{/if}}
                                     {{/if}}
                                     {{if $value.linkType != 'none' && !isPreview && !isDesign}}
                                          {{if $value.useLinkUrl == 1}}
                                             <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                          {{else}}
                                             <a class="goto-link" target="_blank" href="{{$value.link}}">
                                          {{/if}}
                                     {{/if}}
                                        <img src="{{$value.imgUrl? $value.imgUrl: '../../assets/images/img_default.jpg'}}" alt="" cms-smarket>
                                     {{if $value.linkType != 'none' && !isDesign}}
                                         </a>
                                     {{/if}}
                                     {{if style.article.titleStyle.styleType != 'hide' || style.article.descStyle.styleType != 'hide' || style.article.timeStyle.styleType != 'hide' || style.article.button.styleType != 'hide'}}
                                     <div class="info {{tabContent.contentLayout == 'layout-img-top' && style.article.timeStyle.styleType == 'hide' && style.article.button.styleType == 'hide'? 'no-bottom': ''}} {{ (tabContent.contentLayout == 'layout-img-no' && tabContent.styleLayout == 'column3' && style.article.timeStyle.styleType == 'hide' && style.article.button.styleType == 'hide') || (tabContent.contentLayout == 'layout-img-no' && (tabContent.styleLayout == 'column1' || tabContent.styleLayout == 'column2') && style.article.button.styleType == 'hide')? 'no-bottom': ''}}">
                                         {{if $value.linkType != 'none' && isPreview && !isDesign}}
                                              {{if tabContent.addType == 1}}
                                                                                               <a class="goto-link" target="_blank" href="{{$value.link}}">
                                                                                           {{else}}
                                                                                              {{if $value.useLinkUrl == 1}}
                                                                                                    <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                                                                               {{else}}
                                                                                                  {{if $value.id}}
                                                                                                      <a target="_blank" sk-prop.href="$data.articleDetail + '&aid=' + {{$value.id}}">
                                                                                                  {{else}}
                                                                                                      <a target="_blank" sk-prop.href="$data.articleDetail">
                                                                                                  {{/if}}
                                                                                               {{/if}}
                                                                                           {{/if}}
                                         {{/if}}
                                         {{if $value.linkType != 'none' && !isPreview && !isDesign}}
                                            {{if $value.useLinkUrl == 1}}
                                                <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">

                                            {{else}}
                                                <a class="goto-link" target="_blank" href="{{$value.link}}">

                                            {{/if}}
                                         {{/if}}
                                         {{if style.article.titleStyle.styleType != 'hide'}}
                                             <div class="title {{style.article.titleStyle.styleType == 'default'?'medium':style.article.titleStyle.fontSize}}"
                                                 style="{{style.article.titleStyle.styleType == 'default' ? '': 'color:' + style.article.titleStyle.color}}" title="{{$value.title}}">
                                                 {{$value.title}}
                                             </div>
                                         {{/if}}
                                         {{if $value.linkType != 'none' && !isDesign}}
                                             </a>
                                         {{/if}}
                                         {{if $value.linkType != 'none' && isPreview && !isDesign}}
                                              {{if tabContent.addType == 1}}
                                                  <a class="goto-link" target="_blank" href="{{$value.link}}">
                                              {{else}}
                                                  {{if $value.useLinkUrl == 1}}
                                                        <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                                   {{else}}
                                                        {{if $value.id}}
                                                            <a target="_blank" sk-prop.href="$data.articleDetail + '&aid=' + {{$value.id}}">
                                                        {{else}}
                                                            <a target="_blank" sk-prop.href="$data.articleDetail">
                                                        {{/if}}
                                                   {{/if}}
                                              {{/if}}
                                         {{/if}}
                                         {{if $value.linkType != 'none' && !isPreview && !isDesign}}
                                            {{if $value.useLinkUrl == 1}}
                                                <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                            {{else}}
                                                <a class="goto-link" target="_blank" href="{{$value.link}}">
                                            {{/if}}
                                         {{/if}}
                                             {{if style.article.descStyle.styleType != 'hide'}}
                                                 <div class="desc {{style.article.descStyle.styleType == 'default'?'medium':style.article.descStyle.fontSize}}"
                                                      style="{{style.article.descStyle.styleType == 'default' ? '' : 'color:' + style.article.descStyle.color}}">
                                                     {{$value.desc}}
                                                 </div>
                                             {{/if}}
                                         {{if $value.linkType != 'none' && !isDesign}}
                                             </a>
                                         {{/if}}
                                         {{if $value.linkType != 'none' && isPreview && !isDesign}}
                                              {{if tabContent.addType == 1}}
                                                  <a class="goto-link" target="_blank" href="{{$value.link}}">
                                              {{else}}
                                                  {{if $value.useLinkUrl == 1}}
                                                        <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                                   {{else}}
                                                        {{if $value.id}}
                                                            <a target="_blank" sk-prop.href="$data.articleDetail + '&aid=' + {{$value.id}}">
                                                        {{else}}
                                                            <a target="_blank" sk-prop.href="$data.articleDetail">
                                                        {{/if}}
                                                   {{/if}}
                                              {{/if}}
                                         {{/if}}
                                         {{if $value.linkType != 'none' && !isPreview && !isDesign}}
                                            {{if $value.useLinkUrl == 1}}
                                                <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                            {{else}}
                                                <a class="goto-link" target="_blank" href="{{$value.link}}">
                                            {{/if}}
                                         {{/if}}
                                             {{if style.article.timeStyle.styleType != 'hide'}}
                                                  <span class="time {{style.article.timeStyle.styleType == 'default'?'medium':style.article.timeStyle.fontSize}}"
                                                  style="{{style.article.timeStyle.styleType == 'default' ? '' : 'color:' + style.article.timeStyle.color}}">{{$value.pushTime}}</span>
                                             {{/if}}
                                         {{if $value.linkType != 'none' && !isDesign}}
                                             </a>
                                         {{/if}}
                                         {{if $value.linkType != 'none' && isPreview && !isDesign}}
                                             {{if tabContent.addType == 1}}
                                                 <a class="goto-link" target="_blank" href="{{$value.link}}">
                                             {{else}}
                                                {{if $value.useLinkUrl == 1}}
                                                      <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                                 {{else}}
                                                    {{if $value.id}}
                                                        <a target="_blank" sk-prop.href="$data.articleDetail + '&aid=' + {{$value.id}}">
                                                    {{else}}
                                                        <a target="_blank" sk-prop.href="$data.articleDetail">
                                                    {{/if}}
                                                 {{/if}}
                                             {{/if}}
                                         {{/if}}
                                         {{if $value.linkType != 'none' && !isPreview && !isDesign}}
                                            {{if $value.useLinkUrl == 1}}
                                               <a href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                                            {{else}}
                                               <a class="goto-link" target="_blank" href="{{$value.link}}">
                                            {{/if}}
                                         {{/if}}
                                             {{if style.article.button.styleType != 'hide'}}
                                                 <span class="more {{style.article.button.styleType == 'default'?'medium':style.article.button.fontSize}}"
                                                      style="{{style.webcast.button.styleType == 'custom' ? 'color: '+style.webcast.button.color+'; background: url(\''+style.webcast.button.imgUrl+'\') '+style.webcast.button.backgroundColor +'; ' : ''}}">
                                                    查看详情
                                                 </span>
                                             {{/if}}
                                         {{if $value.linkType != 'none' && !isDesign}}
                                             </a>
                                         {{/if}}
                                     </div>
                                     {{/if}}
                                 </div>
                                {{/each}}
                            </div>
                        </div>
                        {{/each}}
                        {{/if}}
                    </div>
                    {{if style.article.pagination && style.article.pagination.model !== 'hide'}}
                        {{if isDesign || isPreview}}
                           <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style="{{style.article.pagination}}">
                           </div>
                            {{else}}
                            <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style='{{style.article.pagination|json_encode|raw}}'>
                            </div>
                         {{/if}}
                    {{/if}}
                </div>
                {{/if}}

                <!-- 线下会列表 -->
                {{if tabContent.contentType === 'SEMINAR'}}
                  <div>
                    {{if !tabContent.items || !tabContent.items.length}}
                        <% include('../common/nodata.art') %>
                    {{/if}}
                    {{each tabContent.items}}
                    <div class="file-wrap" id="page_{{$index}}_items"
                                                {{if $index == 0 }}
                                                    style="display: block"
                                                {{/if}}
                                            >
                    <div class="sk-cms-meeting-list {{tabContent.styleLayout}}">

                        {{each $value}}
                            <div class="meeting-item {{style.seminar.lineStyle.model != 'hide' ? 'border-'+ style.seminar.lineStyle.line : ''}} {{tabContent.contentLayout}}" style="border-color: {{style.seminar.lineStyle.color}};">
                            {{if $value.linkType != 'none' && !isDesign}}
                                 <a class="goto-link" target="_blank" href="{{$value.link}}">
                            {{/if}}
                                <img src="{{$value.imgUrl? $value.imgUrl: '../../assets/images/img_default.jpg'}}" alt="" cms-smarket>
                            {{if $value.linkType != 'none' && !isDesign}}
                                </a>
                            {{/if}}
                                <div class="info">
                                {{if $value.linkType != 'none' && !isDesign}}
                                     <a class="goto-link" target="_blank" href="{{$value.link}}">
                                {{/if}}
                                    {{if style.seminar.titleStyle.styleType != 'hide'}}
                                    <div class="title {{style.seminar.titleStyle.styleType == 'default'?'medium':style.seminar.titleStyle.fontSize}}"
                                        style="{{style.seminar.titleStyle.styleType == 'default' ? '': 'color:' + style.seminar.titleStyle.color}}" title="{{$value.title}}">
                                        {{$value.title}}
                                    </div>
                                    {{/if}}
                                {{if $value.linkType != 'none' && !isDesign}}
                                    </a>
                                {{/if}}

                                    {{if $value.linkType != 'none' && !isDesign}}
                                         <a class="goto-link" target="_blank" href="{{$value.link}}">
                                    {{/if}}

                                        {{if style.seminar.timeStyle.styleType != 'hide'}}
                                            <span class="date {{style.seminar.timeStyle.styleType == 'default'?'medium':style.seminar.timeStyle.fontSize}}" style="{{style.seminar.timeStyle.styleType == 'default' ? '': 'color:' + style.seminar.timeStyle.color}}">{{$value.pushTime}}</span>
                                        {{/if}}
                                    {{if $value.linkType != 'none' && !isDesign}}
                                        </a>
                                    {{/if}}

                                    {{if $value.linkType != 'none' && !isDesign}}
                                         <a class="goto-link" target="_blank" href="{{$value.link}}">
                                    {{/if}}
                                        {{if style.seminar.button.styleType != 'hide'}}
                                            <span class="subscribe {{style.seminar.button.styleType == 'default'?'medium':style.seminar.button.fontSize}}"
                                                 style="{{style.seminar.button.styleType == 'custom' ? 'color: '+style.seminar.button.color+'; background: url(\''+style.seminar.button.imgUrl+'\') '+style.seminar.button.backgroundColor +'; ' : ''}}">
                                                立即预约
                                            </span>
                                        {{/if}}
                                    {{if $value.linkType != 'none' && !isDesign}}
                                        </a>
                                    {{/if}}

                                </div>


                        </div>
                          {{/each}}
                                                </div>
                                                </div>
                                                {{/each}}

                                                {{if style.seminar.pagination && style.seminar.pagination.model !== 'hide'}}
                                                                        {{if isDesign || isPreview}}
                                                                           <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style="{{style.seminar.pagination}}">
                                                                           </div>
                                                                            {{else}}
                                                                            <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style='{{style.seminar.pagination|json_encode|raw}}'>
                                                                            </div>
                                                                         {{/if}}
                                                                    {{/if}}
                  </div>
                {{/if}}
                 <!-- 线上会列表 -->
                {{if tabContent.contentType === 'WEBCAST'}}
                   <div>
                                      {{if !tabContent.items || !tabContent.items.length}}
                                          <% include('../common/nodata.art') %>
                                      {{/if}}
                                      {{each tabContent.items}}
                                      <div class="file-wrap" id="page_{{$index}}_items"
                                                                  {{if $index == 0 }}
                                                                      style="display: block"
                                                                  {{/if}}
                                                              >
                                      <div class="sk-cms-meeting-list {{tabContent.styleLayout}}">

                                          {{each $value}}
                                              <div class="meeting-item {{style.webcast.lineStyle.model != 'hide' ? 'border-'+ style.webcast.lineStyle.line : ''}} {{tabContent.contentLayout}}" style="border-color: {{style.webcast.lineStyle.color}};">
                                              {{if $value.linkType != 'none' && !isDesign}}
                                                   <a class="goto-link" target="_blank" href="{{$value.link}}">
                                              {{/if}}
                                                  <img src="{{$value.imgUrl? $value.imgUrl: '../../assets/images/img_default.jpg'}}" alt="" cms-smarket>
                                              {{if $value.linkType != 'none' && !isDesign}}
                                                  </a>
                                              {{/if}}
                                                  <div class="info">
                                                  {{if $value.linkType != 'none' && !isDesign}}
                                                       <a class="goto-link" target="_blank" href="{{$value.link}}">
                                                  {{/if}}
                                                      {{if style.webcast.titleStyle.styleType != 'hide'}}
                                                      <div class="title {{style.webcast.titleStyle.styleType == 'default'?'medium':style.webcast.titleStyle.fontSize}}"
                                                          style="{{style.webcast.titleStyle.styleType == 'default' ? '': 'color:' + style.webcast.titleStyle.color}}" title="{{$value.title}}">
                                                          {{$value.title}}
                                                      </div>
                                                      {{/if}}
                                                  {{if $value.linkType != 'none' && !isDesign}}
                                                      </a>
                                                  {{/if}}

                                                      {{if $value.linkType != 'none' && !isDesign}}
                                                           <a class="goto-link" target="_blank" href="{{$value.link}}">
                                                      {{/if}}
                                                          {{if style.webcast.timeStyle.styleType != 'hide'}}
                                                              <span class="date {{style.webcast.timeStyle.styleType == 'default'?'medium':style.webcast.timeStyle.fontSize}}" style="{{style.webcast.timeStyle.styleType == 'default' ? '': 'color:' + style.webcast.timeStyle.color}}">{{$value.pushTime}}</span>
                                                          {{/if}}
                                                      {{if $value.linkType != 'none' && !isDesign}}
                                                          </a>
                                                      {{/if}}

                                                      {{if $value.linkType != 'none' && !isDesign}}
                                                           <a class="goto-link" target="_blank" href="{{$value.link}}">
                                                      {{/if}}
                                                          {{if style.webcast.button.styleType != 'hide'}}
                                                              <span class="subscribe {{style.webcast.button.styleType == 'default'?'medium':style.webcast.button.fontSize}}"
                                                                   style="{{style.webcast.button.styleType == 'custom' ? 'color: '+style.webcast.button.color+'; background-img: url(\''+style.webcast.button.imgUrl+'\')'+ ';background-color:' +style.webcast.button.backgroundColor +'; ' : ''}}">
                                                                  立即预约
                                                              </span>
                                                          {{/if}}
                                                      {{if $value.linkType != 'none' && !isDesign}}
                                                          </a>
                                                      {{/if}}

                                                  </div>


                                          </div>
                                            {{/each}}
                                                                  </div>
                                                                  </div>
                                                                  {{/each}}

                                                                  {{if style.webcast.pagination && style.webcast.pagination.model !== 'hide'}}
                                                                                          {{if isDesign || isPreview}}
                                                                                             <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style="{{style.webcast.pagination}}">
                                                                                             </div>
                                                                                              {{else}}
                                                                                              <div class="tab-pagination" data-tabid="{{id}}" data-total="{{tabContent.total}}" data-showcount="{{tabContent.showCount}}" data-style='{{style.webcast.pagination|json_encode|raw}}'>
                                                                                              </div>
                                                                                           {{/if}}
                                                                                      {{/if}}
                                    </div>
                 {{/if}}
            </div>

        {{/each}}

    </div>
    {{/if}}

<% include('../common/email.art') %>
</div>
